import { SYSTEM_USER } from '@confluence/web-item-location/entry-points/webFragmentLocations.ts';
import { preloadWebItemLocation } from '@confluence/web-item-location/entry-points/preloadWebItemLocation.ts';

export const preloadProfileMenu = () => {
	return preloadWebItemLocation({ location: SYSTEM_USER });
};
